import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from '@mui/material';

/**
 * Reusable confirmation dialog for deleting items
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {function} props.onClose - Function to handle dialog close
 * @param {function} props.onConfirm - Function to handle deletion confirmation
 * @param {Object} props.item - The item to be deleted (legacy support)
 * @param {string} props.itemName - Name of the item to be deleted
 * @param {string} props.itemType - Type of item being deleted (e.g., "game", "console")
 * @returns {JSX.Element} Delete confirmation dialog
 */
const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  item,
  itemName = "",
  itemType = "item"
}) => {
  // Don't render if dialog is not open
  if (!open) return null;
  
  // Support both item object and direct itemName string
  const displayName = item?.name || itemName;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to remove "{displayName}" from your collection?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error">Delete</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
